import React from 'react';
import {
	Card,
	CardHeader,
	Input,
	Container,
	Button,
	Table,
	Row,
} from 'reactstrap';
import { useState } from 'react';
import {
	TDROW,
	MasterHeader,
} from '../../common/commonComponents/masterRow/masterRow';
import {
	masterServiceBaseUrl,
	putpost,
	putpost2,
} from 'services/http';
import moment from 'moment';
import IsCoreMaster from '../../common/commonComponents/coreMaster';
import CustomToggle from "views/pages/manage/common/formFeilds/customToggle";
import { failureToast, successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import CustomButton from 'components/CustomButton';

var _ = require('lodash');

const CourseAttributeTable = (props) => {
	const { userPermissions, isSaveVisible, setisSaveVisible = () => { } } = props;

	const [tableDataKey, settableDataKey] = useState('tableDataKey');
	const [isDisabledField, setIsDisabledField] = useState(false);
	const [keyValue, setKeyValue] = useState('');
	const addNewClass = () => {
		props.setclassArray([
			{
				editMode: true,
				__status: '__new',
				courseAttributeKey: null,
				status: 'ACTIVE',
				courseAttributeDesc: null,
				courseAttributeDispValue: null,
				effectiveDate: null,
			},
			...props.classArray,
		]);
	};
	const saveAll = (cb) => {
		var _tempArray = props.classArray;
		var isValid = true;
		_tempArray.forEach((el, index) => {
			if (el['editMode']) {
				if (
					el['courseAttributeDesc'] === null ||
					!el['courseAttributeDesc'].trim()
				) {
					isValid = false;
					failureToast('Please enter the value of Description');
					return;
				} else if (
					el['courseAttributeDispValue'] === null ||
					!el['courseAttributeDispValue'].trim()
				) {
					isValid = false;
					failureToast('Please enter the value of Display Value');
					return;
				}
				if (!isValid) {
					return;
				}
				if (_tempArray[index]['__status'] == '__new') {
					// console.log('TempArray---->', _tempArray[index]);
					_tempArray[index]['courseAttributeDesc'] = _tempArray[index][
						'courseAttributeDesc'
					]
						.replace(/\s+/g, ' ')
						.trim();
					_tempArray[index]['courseAttributeDispValue'] = _tempArray[index][
						'courseAttributeDispValue'
					]
						.replace(/\s+/g, ' ')
						.trim();
					putpost(
						masterServiceBaseUrl + '/courseAttribute/createCourseAttribute',
						(data) => {
							successToast(data['message']);
							setisSaveVisible(false);
							props.fetchClasses(
								masterServiceBaseUrl + '/courseAttribute/getAllCourseAttribute'
							);
							setKeyValue('');
						},
						(data) => {
							failureToast(data['message']);
						},
						_tempArray[index],
						'post'
					);
				} else {
					putpost(
						masterServiceBaseUrl +
						'/courseAttribute/updateCourseAttribute/' +
						_tempArray[index].id,
						(data) => {
							successToast(data['message']);
							setisSaveVisible(false);
							delete _tempArray[index]['editMode'];
							props.setclassArray(_tempArray);
							setIsDisabledField(false);
							settableDataKey(new Date().getMilliseconds());
						},
						(data) => {
							failureToast(data['message']);
						},
						_tempArray[index],
						'put'
					);
				}
			} else {
			}
		});
	};
	const newRow = () => {
		if (isSaveVisible) {
			failureToast('Please Delete or Save current changes');
		} else {
			setKeyValue('');
			let cb = () => {
				addNewClass();
				setisSaveVisible(true);
				// settableDataKey(new Date().getMilliseconds())
			};
			var _tempArray = props.classArray;
			_tempArray = _.sortBy(_tempArray, [
				function (o) {
					return o.value;
				},
			]);
			props.setclassArray(_tempArray);
			setisSaveVisible(false);
			cb();
		}
	};
	const editRow = (index) => {
		if (isSaveVisible) {
			failureToast('Please Delete or Save current changes');
		} else {
			let cb = () => {
				var _tempArray = props.classArray;
				_tempArray[index]['editMode'] = true;
				props.setclassArray(_tempArray);
				setisSaveVisible(true);
				setIsDisabledField(true);
			};
			var _tempArray = props.classArray;
			_tempArray = _.sortBy(_tempArray, [
				function (o) {
					return o.value;
				},
			]);
			cb();
		}
	};
	const deleteRow = (index) => {
		if (props.classArray[index]['__status'] == '__new') {
			let n = props.classArray;
			n.splice(index, 1);
			props.setclassArray(n);
			setisSaveVisible(false);
			settableDataKey(new Date().getMilliseconds());
		} else {
			if (
				window.confirm('Are you sure you want to delete this Course Attribute?')
			) {
				putpost2(
					masterServiceBaseUrl +
					'/courseAttribute/deleteCourseAttribute/' +
					props.classArray[index].id,
					(data) => {
						successToast(data['message']);
						var _tempArray = props.classArray;
						if (_tempArray[index]['editMode']) {
							setisSaveVisible(false);
						}
						_tempArray.splice(index, 1);
						props.setclassArray(_tempArray);
						settableDataKey(new Date().getMilliseconds());
					},
					(data) => {
						failureToast(data['message']);
					},
					'Delete'
				);
			}
		}
	};
	const updateKey = (index, value, key) => {
		if (key === 'courseAttributeDispValue') {
			setKeyValue(value);
		}
		var _tempArray = props.classArray;
		_tempArray[index][key] = value;
		props.setclassArray(_tempArray);
	};
	return (
		<>
			<Container className="mt-3" fluid>
				<Row>
					<div className="col">
						<Card>
							<CardHeader className="border-0">
								<h3 className="mb-0 floatLeft">Master - Course Attribute</h3>
								<IsCoreMaster
									master={'courseAttribute'}
									masterDisplayValue={'Course Attribute'}
								/>
								<CustomButton
									disabled={isSaveVisible}
									className={
										'floatRight mx-1' +
										(isSaveVisible ? ' btn-dark cursor-gray' : null)
									}
									content={'New Course Attribute'}
									permissionType={'C'}
									icon={true}
									onClick={() => {
										newRow();
									}}
									permissionSet={userPermissions}
								/>
							</CardHeader>
							<div id="questionTable" className="table-responsive">
								<Table className="align-items-center table-flush tableLayout">
									<MasterHeader
										type={'attribute'}
										isRequired={true}
										isSaveVisible={isSaveVisible}
										permissionSet={userPermissions}
									/>
									<tbody className="list" key={tableDataKey}>
										{props.classArray
											? props.classArray.map((el, index) =>
												!el['editMode'] ? (
													<TDROW
														type={'courseAttribute'}
														index={index}
														el={el}
														editRow={editRow}
														deleteRow={deleteRow}
														isSaveVisible={isSaveVisible}
														permissionSet={userPermissions}
													/>
												) : (
													<tr key={index + '-class'}>
														<td className="text-center p-2 mx-1">
															<Input
																data-testid="courseAttributeKey"
																maxLength="50"
																defaultValue={
																	el['__status'] == '__new'
																		? keyValue
																		: el['courseAttributeKey']
																}
																disabled={true}
																className="tdInput"
															/>
														</td>
														<td className="text-center p-2 mx-1">
															<Input
																data-testid="effectiveDate"
																maxLength="50"
																disabled={true}
																defaultValue={
																	el['__status'] == '__new'
																		? null
																		: moment(el['eff_date']).format(
																			'DD-MM-YYYY'
																		)
																}
																placeholder="Example:01-01-2020"
																className="tdInput"
															/>
														</td>
														<td className="text-center p-2 mx-1">
															<Input
																data-testid="courseAttributeDesc"
																maxLength="50"
																defaultValue={el['courseAttributeDesc']}
																onChange={(e) => {
																	updateKey(
																		index,
																		e.target.value,
																		'courseAttributeDesc'
																	);
																}}
																placeholder="Description"
																className="tdInput"
															/>
														</td>
														<td className="text-center p-2 mx-1">
															<Input
																data-testid="courseAttributeDispValue"
																maxLength="50"
																defaultValue={el['courseAttributeDispValue']}
																disabled={isDisabledField}
																onChange={(e) => {
																	updateKey(
																		index,
																		e.target.value.toUpperCase(),
																		'courseAttributeDispValue'
																	);
																}}
																placeholder="Display Value"
																className="tdInput"
															/>
														</td>
														<td className="text-center p-2 mx-1">
															<CustomToggle
																status={el.status}
																data-testid="activeInactiveInput"
																id={el.id}
																toggleOn={"Active"}
																toggleOff={"Inactive"}
																onChangeHandler={(e) => {
																	settableDataKey(
																		new Date().getMilliseconds()
																	);
																	let n = 'ACTIVE';
																	if (!e.target.checked) {
																		n = 'INACTIVE';
																	}
																	updateKey(index, n, 'status');
																}}
															/>
														</td>
														<td className="text-center">
															{isSaveVisible ? (
																<>
																	<CustomButton
																		content={'Save'}
																		permissionType={'C,U'}
																		forTable={true}
																		onClick={() => {
																			saveAll();
																		}}
																		permissionSet={userPermissions}
																	/>
																	<CustomButton
																		permissionType={'cancel'}
																		icon={true}
																		forTable={true}
																		onClick={() => {
																			let n = props.classArray;
																			if (n[index]['__status'] == '__new') {
																				n.splice(index, 1);
																			} else {
																				// n[index]['editMode']=false
																				props.fetchClasses(
																					masterServiceBaseUrl +
																					'/courseAttribute/getAllCourseAttribute'
																				);
																			}
																			props.setclassArray(n);
																			setisSaveVisible(false);
																			setIsDisabledField(false);
																		}}
																		permissionSet={userPermissions}
																	/>
																</>
															) : (
																<CustomButton
																	permissionType={'D'}
																	icon={true}
																	forTable={true}
																	onClick={() => deleteRow(index)}
																	permissionSet={userPermissions}
																/>
															)}
														</td>
													</tr>
												)
											)
											: null}
									</tbody>
								</Table>
							</div>
						</Card>
					</div>
				</Row>
			</Container>
		</>
	);
};
export default CourseAttributeTable;
